
export const UNIDAD_MEDIDA = {
    UNIDADES_ENTERAS: 480,
    UNIDADES_DECIMALES: 481,
    IMPORTE: 482,
    OTROS: 483,
}